// ID Type constants for Individual customers
export const ID_TYPE_INDIVIDUAL = {
  CMTND: '30000', // CMTND
  PASSPORT: '30001', // Hộ chiếu
  CCCD: '30002', // CCCD
  OTHER: '30003', // Loại giấy tờ khác
}

// ID Type constants for Business/Household customers
export const ID_TYPE_BUSINESS = {
  BUSINESS_LICENSE: '20000', // Giấy phép đăng ký kinh doanh
  ESTABLISHMENT_LICENSE: '20001', // Giấy phép thành lập
  ESTABLISHMENT_DECISION: '20002', // Quyết định thành lập
  OTHER: '20003', // Loại giấy tờ khác
}

// Backward compatibility - use individual types as default
export const ID_TYPE = ID_TYPE_INDIVIDUAL

export const ID_TYPE_OPTIONS_INDIVIDUAL = [
  {
    value: ID_TYPE_INDIVIDUAL.CCCD,
    labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionIdTypeCCCD',
  },
]

export const ID_TYPE_OPTIONS_BUSINESS = [
  {
    value: ID_TYPE_BUSINESS.BUSINESS_LICENSE,
    labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionIdTypeBusinessLicense',
  },
  // {
  //   value: ID_TYPE_BUSINESS.ESTABLISHMENT_LICENSE,
  //   labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionIdTypeEstablishmentLicense',
  // },
  // {
  //   value: ID_TYPE_BUSINESS.ESTABLISHMENT_DECISION,
  //   labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionIdTypeEstablishmentDecision',
  // },
  // {
  //   value: ID_TYPE_BUSINESS.OTHER,
  //   labelKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionIdTypeOther',
  // },
]

// Gender constants
export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
}

export const GENDER_OPTIONS = [
  {
    value: GENDER.MALE,
    textKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionGenderMale',
  },
  {
    value: GENDER.FEMALE,
    textKey: 'stepGuideControl.stepVerifyInfo.formVerifyContract.optionGenderFemale',
  },
]

// V-Contract Status constants
export const V_CONTRACT_STATUS = {
  INIT: 'INIT',
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  FINISHED: 'FINISHED',
  REJECTED: 'REJECTED',
  CANCEL: 'CANCEL',
}
